import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css'
import Vant from 'vant'
import store from './store'
import 'vant/lib/index.css'
import './until/rem'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import './common/font/font.css';

Vue.config.ignoredElements = ['wx-open-launch-weapp'];


// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.use(Vant)
Vue.use(VideoPlayer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
